var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5301",
    "data-name": "Rectangle 5301",
    width: 32,
    height: 32,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27712",
    "data-name": "Path 27712",
    d: "M18,2A15.927,15.927,0,1,0,29.335,6.665,16,16,0,0,0,18,2Zm0,5.818a5.818,5.818,0,1,1-5.818,5.818A5.818,5.818,0,0,1,18,7.818ZM18,31.09A13.236,13.236,0,0,1,9.127,27.6,19.2,19.2,0,0,1,18,25.272,19.2,19.2,0,0,1,26.872,27.6,13.236,13.236,0,0,1,18,31.09Z",
    transform: "translate(-2 -2)",
    fill: "#1d1d26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatter);
export default __webpack_public_path__ + "static/media/Chatter.159dbfe140ab7004cec2c821c20a1560.svg";
export { ForwardRef as ReactComponent };